import { get } from '../../../../../../Utility/Http';
import { loginDetailsListingGet } from '../Model/LoginActivityModel';
// import Config from '../../../../Utility/Config';

export const loginDetailsListing = (data) => {
    return get(`${process.env.EXTENDED_URL}admin/user_login_activities`, data).then((response) => {
        return loginDetailsListingGet(response)
    });
};